// import Login from '@/view/user/Login.vue'
// import Registered from '@/view/user/Registered.vue'
// import RetrievePasswordOne from '@/view/user/RetrievePasswordOne.vue'
// import RetrievePasswordTwo from '@/view/user/RetrievePasswordTwo.vue'
// import RegisteredFulfill from '@/view/user/RegisteredFulfill.vue'

const routes = [
  { 
    path: '/login', 
    name: 'login', 
    component: () => import('@/view/user/Login.vue')
  },
  { 
    path: '/registered', 
    name: 'registered', 
    component: () => import('@/view/user/Registered.vue')
  },
  { 
    path: '/retrievePasswordOne', 
    name: 'retrievePasswordOne', 
    component: () => import('@/view/user/RetrievePasswordOne.vue')
  },
  { 
    path: '/retrievePasswordTwo', 
    name: 'retrievePasswordTwo', 
    component: () => import('@/view/user/RetrievePasswordTwo.vue')
  },
  { 
    path: '/retrievePasswordOneFulfill', 
    name: 'retrievePasswordOneFulfill', 
    component: () => import('@/view/user/RetrievePasswordOneFulfill.vue')
  },
  { 
    path: '/registeredFulfill', 
    name: 'registeredFulfill', 
    component: () => import('@/view/user/RegisteredFulfill.vue')
  },
]

export default { routes }